"use strict";
exports.__esModule = true;
exports.MINMAX_ARTICLE_WIDTH = void 0;
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var propTypes_1 = require("../../propTypes");
var ListItem_1 = tslib_1.__importDefault(require("./ListItem"));
exports.MINMAX_ARTICLE_WIDTH = 300;
var Wrapper = styled_components_1["default"]('section')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-gap: ", "px;\n"], ["\n  display: grid;\n  grid-template-columns: ",
    ";\n  grid-gap: ", "px;\n"])), function (_a) {
    var theme = _a.theme;
    return "repeat(auto-fill, minmax(calc(" + exports.MINMAX_ARTICLE_WIDTH + "px - " + theme.grid.gutterWidth + "px), 1fr))";
}, function (_a) {
    var theme = _a.theme;
    return theme.grid.gutterWidth;
});
var C = function (_a) {
    var className = _a.className, renderLink = _a.renderLink, articles = _a.articles, showPicture = _a.showPicture;
    return (react_1["default"].createElement(Wrapper, { className: className }, articles.map(function (article) { return (react_1["default"].createElement(ListItem_1["default"], { key: article._id, article: article, renderLink: renderLink, showPicture: showPicture })); })));
};
C.propTypes = {
    className: prop_types_1["default"].string,
    showPicture: prop_types_1["default"].bool,
    articles: prop_types_1["default"].arrayOf(propTypes_1.ArticlePropType).isRequired,
    renderLink: prop_types_1["default"].func.isRequired
};
C.defaultProps = {
    className: null,
    showPicture: true
};
exports["default"] = C;
var templateObject_1;
